import * as React from 'react';

import BoxAiLogo from './BoxAiLogo';

export const boxAiLogo = () => <BoxAiLogo />;

export default {
    title: 'Icon/Logo/BoxAiLogo',
    component: BoxAiLogo,
    parameters: {
        notes: "`import BoxAiLogo from 'box-ui-elements/es/icon/logo/BoxAiLogo';`",
    },
};
